<div class="d-flex justify-content-center align-items-center h-100">
    <div class="text-center">
        <img src="images/empty-state.svg" alt="empty state" />

        <h5 class="mt-3">Welcome to Depo Prep</h5>

        <button class="btn btn-primary mt-3" routerLink="/cases/create">
            <i class="fa-solid fa-plus me-2"></i>Create New Case
        </button>
    </div>
</div>